/* istanbul ignore file */

import { lazyWithPreload } from './utils'

export const BankLinkSuccess = lazyWithPreload(async () => {
  return {
    default: (await import('pages/BankLinkSuccess')).BankLinkSuccess,
  }
})

export const ChooseFundingSource = lazyWithPreload(async () => {
  return {
    default: (await import('pages/ChooseFundingSource')).ChooseFundingSource,
  }
})

export const ContactInfo = lazyWithPreload(async () => {
  return {
    default: (await import('pages/ContactInfo')).ContactInfo,
  }
})

export const DateOfBirth = lazyWithPreload(async () => {
  return {
    default: (await import('pages/DateOfBirth')).DateOfBirth,
  }
})

export const Funding = lazyWithPreload(async () => {
  return {
    default: (await import('pages/Funding')).Funding,
  }
})

export const HDYHAU = lazyWithPreload(async () => {
  return {
    default: (await import('pages/HDYHAU')).HDYHAU,
  }
})

export const DirectBankIntegration = lazyWithPreload(async () => {
  return {
    default: (await import('pages/Institutions/DirectIntegration')).DirectBankIntegration,
  }
})

export const DirectBankIntegrationRedirect = lazyWithPreload(async () => {
  return {
    default: (await import('pages/Institutions/DirectIntegration')).DirectBankIntegrationRedirect,
  }
})

export const InvestInterstitial = lazyWithPreload(async () => {
  return {
    default: (await import('pages/InvestInterstitial')).InvestInterstitial,
  }
})

export const InvestorQuestions = lazyWithPreload(async () => {
  return {
    default: (await import('pages/InvestorQuestions')).InvestorQuestions,
  }
})

export const LaterInterstitial = lazyWithPreload(async () => {
  return {
    default: (await import('pages/LaterInterstitial')).LaterInterstitial,
  }
})

export const LaterIraRecommendation = lazyWithPreload(async () => {
  return {
    default: (await import('pages/LaterIraRecommendation')).LaterIraRecommendation,
  }
})

export const LaterSuitabilityQuestions = lazyWithPreload(async () => {
  return {
    default: (await import('pages/LaterSuitabilityQuestions')).LaterSuitabilityQuestions,
  }
})

export const MfaSetup = lazyWithPreload(async () => {
  return {
    default: (await import('pages/MFASetup')).MfaSetup,
  }
})

export const PersonalInfo = lazyWithPreload(async () => {
  return {
    default: (await import('pages/PersonalInfo')).PersonalInfo,
  }
})

export const PhoneNumber = lazyWithPreload(async () => {
  return {
    default: (await import('pages/PhoneNumber')).PhoneNumber,
  }
})

export const PlaidLinkRedirect = lazyWithPreload(async () => {
  return {
    default: (await import('pages/PlaidLinkRedirect')).PlaidLinkRedirect,
  }
})

export const AboutPortfolio = lazyWithPreload(async () => {
  return {
    default: (await import('pages/PortfolioTheme/AboutPortfolio')).AboutPortfolio,
  }
})

export const PreviewPortfolio = lazyWithPreload(async () => {
  return {
    default: (await import('pages/PortfolioTheme/preview-portfolio')).PreviewPortfolio,
  }
})

export const PricingInterstitial = lazyWithPreload(async () => {
  return {
    default: (await import('pages/PricingInterstitial')).PricingInterstitial,
  }
})

export const ProductOnboarding = lazyWithPreload(async () => {
  return {
    default: (await import('pages/ProductOnboarding')).ProductOnboarding,
  }
})

export const RoundUpsFunding = lazyWithPreload(async () => {
  return {
    default: (await import('pages/RoundUpsFunding')).RoundUpsFunding,
  }
})

export const RoundUpsInterstitial = lazyWithPreload(async () => {
  return {
    default: (await import('pages/RoundUpsInterstitial')).RoundUpsInterstitial,
  }
})

export const RoundUpsPast = lazyWithPreload(async () => {
  return {
    default: (await import('pages/RoundUpsPast')).RoundUpsPast,
  }
})

export const RoundUpsSetup = lazyWithPreload(async () => {
  return {
    default: (await import('pages/RoundUpsSetup')).RoundUpsSetup,
  }
})

export const SSN = lazyWithPreload(async () => {
  return {
    default: (await import('pages/SSN')).SSN,
  }
})

export const OneTimeInvestment = lazyWithPreload(async () => {
  return {
    default: (await import('pages/StartInvesting/OneTime')).OneTimeInvestment,
  }
})

export const LaterOneTimeInvestment = lazyWithPreload(async () => {
  return {
    default: (await import('pages/StartInvesting/OneTime/Later')).LaterOneTimeInvestment,
  }
})

export const RecurringInvestment = lazyWithPreload(async () => {
  return {
    default: (await import('pages/StartInvesting/Recurring')).RecurringInvestment,
  }
})

export const LaterRecurringInvestment = lazyWithPreload(async () => {
  return {
    default: (await import('pages/StartInvesting/Recurring/Later')).LaterRecurringInvestment,
  }
})

export const SubscriptionActive = lazyWithPreload(async () => {
  return {
    default: (await import('pages/SubscriptionActive')).SubscriptionActive,
  }
})

export const Success = lazyWithPreload(async () => {
  return {
    default: (await import('pages/Success')).Success,
  }
})

export const SuitabilityQuestion = lazyWithPreload(async () => {
  return {
    default: (await import('pages/SuitabilityQuestion')).SuitabilityQuestion,
  }
})

export const SuitabilityQuestions = lazyWithPreload(async () => {
  return {
    default: (await import('pages/SuitabilityQuestions')).SuitabilityQuestions,
  }
})

export const ManualFundingSource = lazyWithPreload(async () => {
  return {
    default: (await import('pages/ManualFundingSource')).ManualFundingSource,
  }
})

export const Institutions = lazyWithPreload(async () => {
  return {
    default: (await import('pages/Institutions')).Institutions,
  }
})

export const AddressPreview = lazyWithPreload(async () => {
  return {
    default: (await import('pages/ShippingAddress/AddressPreview')).AddressPreview,
  }
})

export const AddressSuggestion = lazyWithPreload(async () => {
  return {
    default: (await import('pages/ShippingAddress/AddressSuggestion')).AddressSuggestion,
  }
})

export const AddressEdit = lazyWithPreload(async () => {
  return {
    default: (await import('pages/ShippingAddress/AddressEdit')).AddressEdit,
  }
})

export const AddressInvalid = lazyWithPreload(async () => {
  return {
    default: (await import('pages/ShippingAddress/AddressInvalid')).AddressInvalid,
  }
})
